import React, { useState, useEffect } from 'react';
import style from './style.module.scss';
import { RED_500, WHITE, GRAY_200, BLACK } from '../../styles/colors';

interface FeaturedCardPreviewProps {
    image?: string;
    backgroundColor?: string | null;
    title?: string;
    titleColor?: string | null;
    subtitle?: string;
    subtitleColor?: string | null;
    cta?: string;
}

const FeaturedCardPreview: React.FC<FeaturedCardPreviewProps> = ({
    image,
    backgroundColor,
    title,
    titleColor,
    subtitle,
    subtitleColor,
    cta,
}) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        if (!image) {
            setImageLoaded(false);
            return;
        }

        const img = new Image();
        img.onload = () => setImageLoaded(true);
        img.onerror = () => setImageLoaded(false);
        img.src = image;

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [image]);

    return (
        <div className={style.preview_container}>
            <div
                className={style.card_container}
                style={{
                    backgroundColor: backgroundColor || WHITE,
                }}
            >
                <div className={style.content_section}>
                    <div
                        className={style.title}
                        style={{ color: titleColor || BLACK }}
                    >
                        {title || 'Title'}
                    </div>
                    <div
                        className={style.subtitle}
                        style={{
                            color: subtitleColor || titleColor || BLACK,
                        }}
                    >
                        {subtitle || 'Subtitle'}
                    </div>
                </div>
                <div
                    className={style.image_section}
                    style={{
                        backgroundImage:
                            image && imageLoaded ? `url(${image})` : 'none',
                        backgroundColor:
                            image && imageLoaded ? 'transparent' : GRAY_200,
                    }}
                />
                {cta && (
                    <div
                        className={style.cta_button}
                        style={{ backgroundColor: RED_500 }}
                    >
                        <span>{cta}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FeaturedCardPreview;
